var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-expansion-panels',{attrs:{"accordion":""}},[_c('GlassRecycle'),_c('FullRecycle'),_c('Styrofoam')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }